import React from "react";
import { Box, Container } from "@mui/system";
import { Grid, Skeleton, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";

export default function Layout1Section2({ acf }) {
  return (
    <Box
      sx={{
        background: acf?.background_color ? acf.background_color : "#dddddd",
        position: "relative",
        pt: 5,
        pb: 20,
      }}
    >
      <Box
        className="wave"
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          transform: "translateY(-50%)",
          "& svg": {
            width: "100%",
            height: "auto",
          },
        }}
      >
        <svg id="Layer_1" height="80" viewBox="0 0 1376.38 152">
          <defs>
            <style>{`.cls-1{fill: ${acf?.background_color ? acf.background_color : "#dddddd"}`}</style>
          </defs>
          <path
            class="cls-1"
            d="M0,40.87l67.29,9.37c56.92,9,170.75,26.58,284.59,15.6C465.71,54.7,579.54,14.64,693.38,3.5c113.83-11,227.66,6.55,341.5,15.61C1148.71,28,1262.54,28,1319.46,28h56.92V152H0Z"
          ></path>
        </svg>
      </Box>
      <Container
        maxWidth="xl"
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          color: "#fff",
          transform: "translateZ(1px)",
        }}
      >
        <Box
          sx={{
            width: {
              xs: "100%",
            },
          }}
        >
          {acf?.title && acf?.title !== "" ? (
            <Typography
              variant="h1"
              component="h1"
              sx={{
                textAlign: "center",
                fontWeight: 600,
              }}
            >
              {acf.title}
            </Typography>
          ) : null}

          {acf?.subtitle && acf?.subtitle !== "" ? (
            <Typography
              variant="p"
              component="p"
              sx={{
                fontSize: "1.2rem",
                fontWeight: 500,
              }}
            >
              {acf.subtitle}
            </Typography>
          ) : null}

          {acf?.key_features && acf?.key_features.length > 0 ? (
            <Grid
              container
              spacing={4}
              sx={{
                width: "100%",
                marginTop: "20px",
              }}
            >
              {acf.key_features.map((feature, index) => (
                <Grid
                  item
                  xs={12}
                  md={6}
                  key={index}
                  sx={{
                    marginBottom: "0px",
                    display: "flex",
                  }}
                >
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    size="lg"
                    style={{
                      color: "#fff",
                      marginRight: "10px",
                      marginTop: "4px",
                    }}
                  />
                  <Typography key={index}>{feature.feature}</Typography>
                </Grid>
              ))}
            </Grid>
          ) : null}
        </Box>
      </Container>
    </Box>
  );
}
